export default "__VITE_ASSET__D7ORSFS4__"